module.exports = __webpack_public_path__ + "static/media/scan-2.d2986f11.jpg";